// extracted by mini-css-extract-plugin
export default {"iconWrapper":"closeIcon-module__iconWrapper__PyG1O","icon":"closeIcon-module__icon__WAeDp"};